import React from 'react';
import styled from 'styled-components';
import { Flex } from 'grid-styled';
import session from '../session';

const DropPane = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    height: 150px;
    border: 1px solid lightgrey;
    font-family: sans-serif;
    margin-bottom: 10px;
    width: 100%;
    ${p => p.dragover && 'background-color: rgba(0, 255, 0, 0.2)'};
`;

const LogWindow = styled.textarea`
    height: 200px;
    width: 100%;
    resize: none;
    border: 1px solid lightgrey;
`;

// Prevent opening the file within the browser if accidentally dropped on window
window.addEventListener('dragover', e => e.preventDefault(), false);
window.addEventListener('drop', e => e.preventDefault(), false);

class Updater extends React.Component {
    state = {
        uploadProgess: 0.0,
        status: '',
        dragover: false,
        versionNow: '',
        versionPrevious: '',
        completed: false
    };

    componentWillMount() {}

    componentDidMount() {
        this._timeout_upload = setInterval(this.pollStatus, 1000);
    }

    componentWillUnmount() {
        if (this._timeout_upload) {
            clearInterval(this._timeout_upload);
        }
    }

    upload = async file => {
        const form = new FormData();
        form.append('file', file);
        const request = new XMLHttpRequest();

        request.upload.addEventListener('progress', ev => {
            this.setState({ uploadProgress: (100 * ev.loaded) / ev.total });
        });

        request.upload.addEventListener('error', ev => {
            this.setState({ uploadProgress: null });
            console.error('Failed to upload file');
        });

        request.onload = async () => {
            // upload done
            this.setState({ uploadProgress: null });
        };

        try {
            this.state.completed = false;

            session.realm.fetch('/sys/cgi-bin/updater.cgi', {
                request,
                method: 'POST',
                body: form
            });
        } catch (err) {
            console.error('updater:' + err);
        }
    };

    onTimeout = () => {
        const { updateLog } = this.state;
        this.setState({ updateLog: `${updateLog}\nTimeout` });
    };

    pollStatus = async () => {
        try {
            console.log(
                'pollStatus previus=' +
                    this.state.versionPrevious +
                    'now= ' +
                    this.state.versionNow
            );

            const settings = await session.rpc('call', [
                '',
                'version',
                'get',
                {}
            ]);

            this.state.versionPrevious = this.state.versionNow;
            this.state.versionNow = settings[1].versions.rootfs;

            if (
                this.state.versionNow !== '' &&
                this.state.versionPrevious !== '' &&
                this.state.versionPrevious !== this.state.versionNow
            ) {
                // firmware version is changed, so logout and refresh
                console.log('firmware version changed -> logout and refresh');
                session.logout();
                //
                if (this._timeout_upload) {
                    clearInterval(this._timeout_upload);
                }
                // HARD RELOAD IGNORE CACHE (NEW FRONTEND WILL BE LOADED)
                window.location.reload(true);
            }

            if (!this.state.completed) {
                const log = await session.realm.fetch(
                    '/sys/cgi-bin/updater.cgi?request=1'
                );
                const updateLog = log.split('<br>').join('\n');
                this.setState({ updateLog });

                if (/ERROR/.test(updateLog)) {
                    // Error
                    console.log('pollStatus...error');
                    this.state.completed = true;
                } else if (/update completed/.test(updateLog)) {
                    // Complete
                    console.log('pollStatus...complete');
                    this.state.completed = true;
                }
            }
        } catch (err) {
            console.error('pollStatus error:' + err);
        }
    };

    onOpenFile = () => {
        this._fileInput.click();
    };

    onFileChange = ({ target }) => {
        console.log('DROP', target.files);
    };

    dragCount = 0;
    onDragEnter = ev => {
        if (this.dragCount++ === 0) {
            this.setState({ dragover: true });
        }
    };

    onDragLeave = ev => {
        if (--this.dragCount === 0) {
            this.setState({ dragover: false });
        }
    };

    onDrop = ev => {
        const files = ev.dataTransfer.files;
        this.upload(files[0]);
        this.dragCount = 0;
        this.setState({ dragover: false });
    };

    onChange = async ({ target }) => {
        const file = target.files[0];
        this._fileInput.value = null;
        if (!file) {
            return;
        }
        this.upload(file);
    };

    onCancel = () => {
        this.req.abort();
    };

    onRef = ref => (this._fileInput = ref);

    render() {
        const { dragover, uploadProgress, updateLog } = this.state;
        return (
            <Flex flexDirection="column">
                <input
                    type="file"
                    accept=".tar"
                    style={{ display: 'none' }}
                    ref={this.onRef}
                    onChange={this.onChange}
                />
                <DropPane
                    dragover={dragover}
                    onClick={this.onOpenFile}
                    onDragEnter={this.onDragEnter}
                    onDragLeave={this.onDragLeave}
                    onDrop={this.onDrop}
                >
                    <h1>Click or drop file here </h1>

                    {uploadProgress && <h2>{uploadProgress.toFixed(2)}%</h2>}
                </DropPane>

                <LogWindow value={updateLog} />

                <p>Note: this process can take up to 2 minutes.</p>
            </Flex>
        );
    }
}

export default Updater;



// WEBPACK FOOTER //
// ./src/uic/Updater.js